export default __webpack_public_path__ + "static/media/FO.23208d7b.svg";